import { render } from "./destinationView.vue?vue&type=template&id=21107a39&scoped=true"
import script from "./destinationView.vue?vue&type=script&lang=js"
export * from "./destinationView.vue?vue&type=script&lang=js"

import "./destinationView.vue?vue&type=style&index=0&id=21107a39&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21107a39"]])

export default __exports__